import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';

const getUrlSearchParams = (param, queryString) => {
  const searchParam = new RegExp('[?&]' + param + '=([^&#]*)').exec(queryString);
  return searchParam && decodeURI(searchParam[1]);
};

export const shouldDisplayReferrerRecommendations = (referer) => {
  return /google.com|bing.com|yahoo.com|duckduckgo.com|aol.com/i.test(referer)
    || /^Shopping/i.test(getUrlSearchParams('cm_mmc', referer))
    || /PIN_Shopping/i.test(getUrlSearchParams('cm_mmc', referer));

};

export const shouldDisplayVisuallySimilar = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.visualNavigation;
};

export const shouldDisplayPipInStock = (data = {}, referer) => {
  const { product = {} } = data || {};
  if (shouldDisplayReferrerRecommendations(referer)) return false;
  if (podFulFillmentUtils.isDiscontinued(product)) return true;
  if (product.availabilityType?.type === 'Browse Only') return podFulFillmentUtils.isOutOfStockYourStore(product);
  if (product.availabilityType?.type === 'Online') return podFulFillmentUtils.isOutOfStockOnline(product);
  if (product.availabilityType?.type === 'Shared') {
    return !!(podFulFillmentUtils.isOutOfStockOnline(product)
      || podFulFillmentUtils.isOutOfStockShared(product)
      || podFulFillmentUtils.isLimitedStock(product)
      || podFulFillmentUtils.isBackordered(product)
      || !podFulFillmentUtils.isATCEnabled(product));
  }
  if (product?.availabilityType?.type === 'Store Only') {
    return podFulFillmentUtils.isBuyInStore(product);
  }
  return false;
};

export const shouldDisplayPipAlternativeRecs = (data = {}, referer) => {
  return !shouldDisplayReferrerRecommendations(referer) && !shouldDisplayPipInStock(data, referer);
};

export const shouldDisplayPipCollections = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.pipCollections;
};

export const shouldDisplayFbr = () => {
  return false;
};

export const shouldDisplayIrgCollection = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.collections;
};

export const shouldDisplayIrgaccessories = (hideYMAN, data = {}) => {
  return (!hideYMAN && data?.product?.info?.recommendationFlags?.ACC);
};

export const shouldDisplayIrgcollections = (data = {}) => {
  return (shouldDisplayIrgCollection(data) && !shouldDisplayPipCollections(data));
};

export const isBathCategory = (data = {}) => {
  if (data?.product?.taxonomy?.breadCrumbs) {
    return (data?.product?.taxonomy?.breadCrumbs[0]?.label.toLowerCase() === 'bath');
  }
  return false;
};

const removeTypenameDeep = (input) => {
  if (Array.isArray(input)) {
    return input.map(removeTypenameDeep);
  }
  if (input && typeof input === 'object') {
    const { __typename, ...rest } = input;
    return Object.fromEntries(
      Object.keys(rest).map((key) => [key, removeTypenameDeep(rest[key])])
    );
  }
  return input;
};

export const getProductTaxonomy = (data = {}) => {
  return { taxonomy: removeTypenameDeep(data?.product?.taxonomy) };
};

export const shouldDisplayBBTAbove = (hideFBT, hideBBT, productData = {}) => {
  if (!hideFBT || hideBBT) return false;
  const recommendationFlags = productData?.product?.info?.recommendationFlags || {};
  const hasBundleOrPackages = Boolean(recommendationFlags.bundles || recommendationFlags.packages);

  return hideFBT && !hasBundleOrPackages;
};

export const shouldDisplayBBTBelow = (hideFBT, hideYMAN, hideBBT, productData = {}) => {
  if (!hideYMAN || hideBBT) return false;
  const recommendationFlags = productData?.product?.info?.recommendationFlags || {};
  const hasBundleOrPackages = Boolean(recommendationFlags.bundles || recommendationFlags.packages);

  return hideYMAN && (hasBundleOrPackages || !hideFBT);
};